export default __webpack_public_path__ + "static/media/consultant.a9bdd94e.jpg";